import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { AlertDialogService } from "../../components/_alert-dialog/alert-dialog.service";
import { HttpService } from "../../services/http.service";
import { ToolsService } from "../../services/tools.service";
import { Administre } from "../../interfaces/Administre";
import { AdministreDialogService } from "../../dialogs/administre-dialog/administre-dialog.service";

@Component({
  selector: "select-administre",
  templateUrl: "select-administre.html",
  standalone: false,
})
export class SelectAdministre implements OnInit {
  @Input() ngModel: number = 0;
  @Input() disabled?: boolean = false;
  @Input() selectNo?: boolean = false;
  @Input() enableCreate?: boolean = false;
  @Input() enableEdit?: boolean = false;

  @Output() ngModelChange = new EventEmitter();
  @Output() selectionChange = new EventEmitter();

  public oLogUser = JSON.parse(sessionStorage.getItem("Equora_User"));
  public elements: Administre[];
  public filteredElements: ReplaySubject<Administre[]> = new ReplaySubject<
    Administre[]
  >(1);
  public bLoad: boolean;

  constructor(
    private _http: HttpService,
    private _tools: ToolsService,
    private _alert: AlertDialogService,
    private _s: AdministreDialogService
  ) {}

  ngOnInit(): void {
    this.getElements();
  }

  getElements(): void {
    this.bLoad = true;
    this._http.GET(
      "/api/administre",
      null,
      (result) => {
        if (result.isOk) {
          this.elements = result.obj;
          this.filteredElements.next(this.elements.slice());
          this.change();
        } else {
          this._alert.openDialog(
            "Erreur",
            { message: result.message },
            "error"
          );
        }
        this.bLoad = false;
      },
      (error) => {
        this._tools.showHttpError(error);
        this.bLoad = false;
      }
    );
  }

  search(
    search: string,
    elements: Administre[],
    filteredElements: ReplaySubject<Administre[]>
  ) {
    if (!search) {
      filteredElements.next(elements.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filteredElements.next(
      elements.filter((e) => e.administre_RS.toLowerCase().indexOf(search) > -1)
    );
  }

  change(): void {
    this.ngModelChange.emit(this.ngModel);
    const selected = this.elements.find((e) => e.administre_ID == this.ngModel);
    this.selectionChange.emit(selected ?? null);
  }

  open(id: number) {
    this._s.openDialog(id, () => {
      this.getElements();
    });
  }
}
